import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {ShoppingCart} from "@biletix/core/models/shopping-cart/shopping-cart.model";
import {ShoppingItem} from "@biletix/core/models/shopping-cart/shopping-item.model";
import {ShoppingUpsellItem} from "@biletix/core/models/shopping-cart/shopping-upsell-item.model";
import {from} from "rxjs";
import {groupBy, map, mergeMap, toArray} from "rxjs/operators";
import {DeliveryType} from "@biletix/core/common/enums/delivery-type.enum";

@Component({
    selector: 'btx-ticket-summary-list',
    templateUrl: './ticket-summary-list.component.html',
    styleUrls: ['./ticket-summary-list.component.scss'],
    standalone:false
})
export class TicketSummaryListComponent extends AbstractionComponent implements OnInit, OnDestroy {
  @Input() showLiveEvent: boolean = false;

    shoppingCart: ShoppingCart | any;
    eventShoppingItemsMap: Map<string, ShoppingItem[]>;
    eventShoppingUpsellMap: Map<string, ShoppingUpsellItem[]>;

    constructor(private ticketSaleService: TicketSaleService) {
        super();
        this.eventShoppingItemsMap = new Map<string, ShoppingItem[]>();
        this.eventShoppingUpsellMap = new Map<string, ShoppingUpsellItem[]>();
    }

    ngOnInit(): void {
        this.ticketSaleService
            .watchShoppingCart
            .pipe(this.takeUntilDestroy())
            .subscribe(shoppingCart => this.setShoppingCart(shoppingCart));
    }

    setShoppingCart(cart: ShoppingCart) {
        this.shoppingCart = cart;
        this.eventShoppingItemsMap.clear();
        this.eventShoppingUpsellMap.clear();
        if (cart) {
            this.setEventShoppingItemsMap(cart.shoppingItems);
            this.setEventShoppingUpsellMap(cart.shoppingUpsellItems);
        }
    }

    /**
     *
     * @param items
     */
    setEventShoppingItemsMap(items: ShoppingItem[]) {
        from(items)
            .pipe(
                this.takeUntilDestroy(),
                groupBy(item => (item.eventCode + item.performanceCode)),
                mergeMap(group => group.pipe(toArray())),
                map(arr => {

                        let shoppingItem: ShoppingItem = arr[0];
                        const key = shoppingItem.eventCode + shoppingItem.performanceCode;
                        return {key: key, values: arr};
                    }
                )
            ).subscribe(map => this.eventShoppingItemsMap.set(map.key, map.values));
    }

    /**
     *
     * @param items
     */
    setEventShoppingUpsellMap(items: ShoppingUpsellItem[]) {
        from(items)
            .pipe(
                this.takeUntilDestroy(),
                groupBy(item => (item.eventCode + item.performanceCode)),
                mergeMap(group => group.pipe(toArray())),
                map(arr => {
                        let shoppingUpsellItem: ShoppingUpsellItem = arr[0];
                        const key = shoppingUpsellItem.eventCode + shoppingUpsellItem.performanceCode;
                        return {key: key, values: arr};
                    }
                )
            ).subscribe(data => this.eventShoppingUpsellMap.set(data.key, data.values));
    }

    public isHomePrint(): boolean {
        if (this.shoppingCart && this.shoppingCart.deliveryChoice) {
            return this.shoppingCart.deliveryChoice.deliveryType == DeliveryType.HOME_PRINT_DELIVERY;
        }
        return false;
    }


    override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

}
